import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, filter, take } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { AuthService } from '../services/auth.service';
import { NGXLogger } from 'ngx-logger';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  logger.debug('Auth guard - Route:', state.url);
  logger.debug('Auth guard - MSAL initialized:', authService.isInitialized());

  // If MSAL is already initialized, check immediately
  if (authService.isInitialized()) {
    if (authService.isUserAuthenticated()) {
      logger.debug('Auth guard - User authenticated, allowing access');
      return true;
    } else {
      logger.debug('Auth guard - User not authenticated, redirecting to login');
      return router.createUrlTree(['/login']);
    }
  }

  // If MSAL is not initialized yet, wait for it using observables
  logger.debug('Auth guard - MSAL not initialized, waiting...');
  return toObservable(authService.isInitialized).pipe(
    filter((initialized) => initialized), // Wait until initialized is true
    take(1), // Take only the first emission
    map(() => {
      logger.debug('Auth guard - MSAL initialized, checking authentication');
      if (authService.isUserAuthenticated()) {
        logger.debug('Auth guard - User authenticated, allowing access');
        return true;
      } else {
        logger.debug('Auth guard - User not authenticated, redirecting to login');
        return router.createUrlTree(['/login']);
      }
    }),
  );
};
